import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
  'data-ffid'?: string;
};

const Icon: React.FC<Props> = ({ className = '', dimension = 16, 'data-ffid': dataFfid }: Props) => (
  <svg
    width={dimension}
    height={dimension}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    data-ffid={dataFfid}
  >
    <rect width="16" height="16" rx="8" fill="currentColor" />
    <circle cx="8" cy="8" r="4" fill="#fff" />
  </svg>
);

export default Icon;
